module.exports = __webpack_public_path__ + "static/img/logo_100.f32e4507.svg";